import Vue from 'vue'
import freshVueAudits from '@freshsolutions/fresh-vue-audits'
import i18n from './i18n'

Vue.use(freshVueAudits, {
  i18n: i18n
})
